import { createContext } from '@fluentui/react-context-selector';
// eslint-disable-next-line @fluentui/no-context-default-value
export const ComboboxContext = createContext({
    activeOption: undefined,
    appearance: 'outline',
    focusVisible: false,
    open: false,
    registerOption () {
        return ()=>undefined;
    },
    selectedOptions: [],
    selectOption () {
    // noop
    },
    setActiveOption () {
    // noop
    },
    setOpen () {
    // noop
    },
    size: 'medium'
});
export const ComboboxProvider = ComboboxContext.Provider;
